import { motion } from "framer-motion";

const fadeUp = {
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.6, ease: "easeOut" },
};

const SectionHeading = ({ eyebrow, title, text, dark = false, testid }) => (
  <motion.div {...fadeUp} data-testid={testid} className="mx-auto max-w-3xl text-center">
    {eyebrow && (
      <span
        className={`inline-block rounded-full px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.22em] ${
          dark ? "bg-white/10 text-white" : "bg-[#C62828]/10 text-[#C62828]"
        }`}
      >
        {eyebrow}
      </span>
    )}
    <h2
      className={`mt-4 text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-[42px] lg:leading-[1.15] ${
        dark ? "text-white" : "text-[#1F1F1F]"
      }`}
    >
      {title}
    </h2>
    <span className="mx-auto mt-5 block h-[4px] w-16 rounded-full bg-[#C62828]" />
    {text && (
      <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? "text-[#C9C9C9]" : "text-[#666666]"}`}>
        {text}
      </p>
    )}
  </motion.div>
);

export default SectionHeading;
